import React, { useState, useEffect } from "react";
import axios from "axios";
import { environment } from "../../../environments/environments";
import WarningUploadImage from "../../WarningUploadImage/WarningUploadImage";
import "../CounsellorallEditPages/CounsellorImageUpdate.css";
import { getUserById } from "../../api/api";

const CounsellorImageUpdate = ({ navigation }) => {
  const MAX_IMAGE_SIZE = 10 * 1024 * 1024;

  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(true);

  useEffect(() => {
    const getUserdata = async () => {
      try {
        const userData = localStorage.getItem("currentUser");
        const parsedUserData = JSON.parse(userData);
        const _id = parsedUserData?.id || parsedUserData?._id;

        if (_id) {
          const res = await getUserById({ user_id: _id });
          console.log("getUserById_data", res);
          setUserData(res?.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        // setLoading(false);
      }
    };

    getUserdata();
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > MAX_IMAGE_SIZE) {
      alert("File exceeds the 10MB limit.");
      return;
    }

    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleSubmit = async () => {
    if (!imageFile) {
      alert("Please select an image");
      return;
    }

    setIsLoading(true);
    try {
      const storedUser = localStorage.getItem("currentUser");
      const parsed = JSON.parse(storedUser);
      const _id = parsed?.id || parsed?._id;

      const formData = new FormData();
      formData.append("counsellor_id", _id);
      formData.append("image", imageFile);

      const response = await axios.post(
        `${environment.baseURL}/update-counsellor`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("api response", response);
      if (response.data?.success) {
        alert("Profile image updated successfully");
        window.location.href = "/CounsellorSidebar/CounsellorEditProfile";
      } else {
        alert(response.data?.message || "Update failed");
      }
    } catch (err) {
      console.error("Upload error:", err);
      alert("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="uplode-scroll-wrapper">
        <div className="image-update-container">
          {isModalVisible && (
            <WarningUploadImage setIsModalVisible={setIsModalVisible} />
          )}

          <p className="instructions">
            Tap to upload an image from camera or gallery
          </p>

          <div className="image-box">
            <img
              src={
                imagePreview
                  ? imagePreview
                  : userData?.image
                    ? `${environment.url}/uploads/counsellors/${userData.image}`
                    : "/default-avatar.png"
              }
              alt="Profile"
              className="preview-image"
            />
            <label className="edit-icon">
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                hidden
              />
              ✎
            </label>
          </div>

          <button
            className="continue-button"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? "Uploading..." : "Continue"}
          </button>
          <button className="back-button" onClick={() => window.history.back()}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default CounsellorImageUpdate;
